import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Text } from "@redotech/redo-web/text";
import { getFaireCallbackPath } from "./callback-path";

export const faireCallbackRedirectRoute: PermissionedRouteObject = {
  path: "/faire/callback",
  loader() {
    const path = getFaireCallbackPath(new URL(location.href));
    if (!path) {
      throw new Response("Invalid Faire callback parameters", { status: 400 });
    }
    // A full navigation makes AuthProvider load the destination store's token.
    location.replace(path);
    return null;
  },
  element: <Text>Returning to your store...</Text>,
  errorElement: (
    <Text>Invalid parameters to complete Faire authentication.</Text>
  ),
};

export const faireRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Faire" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { FaireCallback } = await import("./callback");
          return { Component: FaireCallback };
        },
      },
    ],
  },
];
